import { createAction } from 'typesafe-actions';
import { AdminHeaderInfos } from './adminHeaderTypes'

export const adminHeaderSetStore = createAction('ADMIN_HEADER_SET_STORE')<AdminHeaderInfos>();

export const adminHeaderActions = {
    adminHeaderSetStore
};